import { c as _c } from "react/compiler-runtime";
import { Sidebar, SidebarBody } from "@/components/ui/sidebar";
import { Skeleton } from "@/components/ui/skeleton";
export default function MainSidebarSkeleton() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between px-1 py-2"><Skeleton className="h-7 w-[134px]" /><Skeleton className="rounded-ds-xs h-6 w-6" /></div>;
    t1 = <Skeleton className="rounded-ds-md h-11 w-full" />;
    t2 = <Skeleton className="rounded-ds-md h-11 w-full" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-3">{t0}{t1}{t2}<div className="space-y-4 pt-2">{Array.from({
          length: 3
        }).map(_temp2)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Sidebar><SidebarBody className="bg-ds-surface-secondary fixed left-0 top-[var(--banner-offset,0px)] h-[calc(100vh-var(--banner-offset,0px))] px-3 py-3 dark:bg-zinc-950"><div className="flex h-full flex-col justify-between">{t3}<div className="space-y-3"><Skeleton className="rounded-ds-md h-24 w-full" /><Skeleton className="rounded-ds-md h-12 w-full" /></div></div></SidebarBody></Sidebar>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp2(_, sectionIdx) {
  return <div key={sectionIdx} className="space-y-2"><Skeleton className="h-3 w-16" /><div className="space-y-1">{Array.from({
        length: 3
      }).map(_temp)}</div></div>;
}
function _temp(__, itemIdx) {
  return <Skeleton key={itemIdx} className="rounded-ds-sm h-9 w-full" />;
}